import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FeatureIcon from 'components/generalUI/FeatureIcon';
import { TicketFeature } from 'apollo/types';
import {
  getExcludedFeatures,
  getOfferedFeatures,
} from 'utils/helpers/getIncludedFeatures';
import getFeatureIconVariant from 'utils/helpers/getFeatureIconVariant';
import getFeatureLabel, { getFeatureNote } from 'utils/helpers/getFeatureLabel';
import styles from './TicketIncludes.module.scss';

interface TicketIncludesProps {
  features: TicketFeature[];
}

const TicketIncludes: FC<TicketIncludesProps> = ({ features }: TicketIncludesProps) => {
  const { t } = useTranslation();

  const offered = getOfferedFeatures(features);
  const excluded = getExcludedFeatures(features);

  const renderList = (items: TicketFeature[]) => (
    <ul className={styles.List}>
      {items.map((feature) => {
        const note = getFeatureNote(feature, t);
        return (
          <li key={feature.slug}>
            {feature.name}
            {note && <span className={styles.Note}>{` (${note})`}</span>}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      {offered.length > 0 && (
        <section className={styles.Section}>
          <div className={styles.IncludesHeader}>
            <h2 className={styles.Title}>{t('pages.ticketInformation.whatIncludes')}</h2>
            <div className={styles.Icons}>
              {offered.map((feature, index) => (
                <FeatureIcon
                  key={feature.slug}
                  icon={feature.slug}
                  variant={getFeatureIconVariant(feature, index)}
                  description={getFeatureLabel(feature, t)}
                />
              ))}
            </div>
          </div>
          {renderList(offered)}
        </section>
      )}

      {excluded.length > 0 && (
        <section className={styles.Section}>
          <h2 className={styles.Title}>{t('pages.ticketInformation.whatExcludes')}</h2>
          {renderList(excluded)}
        </section>
      )}
    </>
  );
};

export default TicketIncludes;
